import React from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Helmet } from 'react-helmet';

const constructPages = ({ pageSize, itemCount }) => {
  const pages = Math.ceil(itemCount / pageSize);
  if (pages <= 1) return [];
  return _.range(pages).map((idx) => ({
    page: idx + 1,
    offset: idx * pageSize
  }));
}

const elidePages = (pages, currentPage) => {
  const firstPage = 1;
  const prevPage = currentPage - 1;
  const nextPage = currentPage + 1;
  const lastPage = pages.length;

  const elideBeginning = (pages, rightEdge) => {
    const leftEdge = firstPage + 1;
    rightEdge = Math.min(lastPage - 5, rightEdge)
    return swapWithEllipsis(pages, leftEdge, rightEdge);
  }

  const elideEnding = (pages, leftEdge) => {
    leftEdge = Math.max(leftEdge, firstPage + 5);
    const rightEdge = lastPage - 1;
    return swapWithEllipsis(pages, leftEdge, rightEdge);
  }

  const swapWithEllipsis = (pages, start, end) => {
    if (end - start < 1) return pages;
    const startIdx = _.findIndex(pages, { page: start });
    const endIdx = _.findIndex(pages, { page: end });
    return [
      ...pages.slice(0, startIdx),
      { page: '...' },
      ...pages.slice(endIdx + 1)
    ];
  }

  pages = elideBeginning(pages, prevPage - 1);
  pages = elideEnding(pages, nextPage + 1);
  return pages
}

const PageButton = ({ text, path, isActive }) => {
  if (isActive) {
    return (
      <span className="category-pagination-button category-pagination-button-selected">
        {text}
      </span>
    )
  } else if (text === '...') {
    return (
      <span className="category-pagination-button category-pagination-button-fill">
        {text}
      </span>
    )
  } else {
    return (
      <Link className="category-pagination-button"
        to={path}>
        {text}
      </Link>
    )
  }
}

const Pagination = (props) => {
  const {
    itemCount,
    offset,
    pageSize,
    pathForOffset
  } = props;

  if (itemCount <= pageSize) return null;

  const currentPageIdx = Math.floor(offset / pageSize);
  const currentPage = currentPageIdx + 1;

  const pageLinks = constructPages({ itemCount, pageSize });

  const prevPage = pageLinks[currentPageIdx - 1];
  const nextPage = pageLinks[currentPageIdx + 1];
  const prevUrl = prevPage ? pathForOffset(prevPage.offset) : null;
  const nextUrl = nextPage ? pathForOffset(nextPage.offset) : null;

  const displayedPages = elidePages(pageLinks, currentPage);

  const output = (
    <div>
      { prevUrl && <Link to={prevUrl} className="category-pagination-button prev-button">Previous</Link> }
      { displayedPages.map((link, idx) => {
        const text = link.page;
        const path = _.has(link, 'offset') ? pathForOffset(link.offset) : null;
        const key = path || `${idx} ${text}`
        const isActive = link.page === currentPage;
        return <PageButton key={key} text={text} path={path} isActive={isActive} />
      }) }
      { nextUrl && <Link to={nextUrl} className="category-pagination-button next-button">Next</Link> }
      <Helmet>
        { prevUrl && <link rel="prev" href={prevUrl} /> }
        { nextUrl && <link rel="next" href={nextUrl} /> }
      </Helmet>
    </div>
  )

  return output;
};

export default Pagination;
export { constructPages, elidePages, PageButton };



// WEBPACK FOOTER //
// ./shared/components/ui/pagination/index.js